module.exports = __webpack_public_path__ + "img/pricing.a603e255.png";